var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#666666",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5H14C14.55 5 15 4.55 15 4C15 3.45 14.55 3 14 3H4C3.45 3 3 3.45 3 4C3 4.55 3.45 5 4 5ZM14 6H4C2.9 6 2 6.9 2 8V19C2 20.1 2.9 21 4 21H14C15.1 21 16 20.1 16 19V8C16 6.9 15.1 6 14 6ZM11.5 15H10.5V16C10.5 16.83 9.83 17.5 9 17.5C8.17 17.5 7.5 16.83 7.5 16V15H6.5C5.67 15 5 14.33 5 13.5C5 12.67 5.67 12 6.5 12H7.5V11C7.5 10.17 8.17 9.5 9 9.5C9.83 9.5 10.5 10.17 10.5 11V12H11.5C12.33 12 13 12.67 13 13.5C13 14.33 12.33 15 11.5 15ZM20 6C18.32 6 17 7.76 17 10C17 11.77 17.83 13.22 19 13.76V20C19 20.55 19.45 21 20 21C20.55 21 21 20.55 21 20V13.76C22.17 13.22 23 11.77 23 10C23 7.76 21.68 6 20 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedications);
export default __webpack_public_path__ + "static/media/medications.d37d50ae9fc5cfb89161377797b5928d.svg";
export { ForwardRef as ReactComponent };